<template>
  <div class="app">
    <main>
      <div class="left-panel">
        <sound-selector></sound-selector>
      </div>
      <div class="right-panel">
        <chord-selector></chord-selector>
      </div>
    </main>

    <footer>
      <div class="key-holder">
        <keyboard></keyboard>
      </div>
      <ads-container></ads-container>
      <social-footer></social-footer>
    </footer>
  </div>
</template>

<script>
import Keyboard from './keyboard/keyboard.vue';
import SoundSelector from './sound-selector/sound-selector.vue';
import ChordSelector from './chord-selector/chord-selector.vue';
import AdsContainer from './ads-container/ads-container.vue';
import SocialFooter from './social-footer/social-footer.vue';

export default {
  components: {
    Keyboard,
    SoundSelector,
    ChordSelector,
    AdsContainer,
    SocialFooter
  }
};
</script>

<style lang="scss" scoped>
.app {
  background-image: url('../assets/wood.jpg');
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

main {
  max-height: calc(100vh - 302px);
  width: 100vw;
  display: flex;
  color: white;
}

footer {
  border-top: 5px solid #c0392b;
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	text-align: center;
  background-color: rgba(0, 0, 0, 0.6);
}

.left-panel,
.right-panel {
  flex: 1;
  display: flex;
  flex-flow: row wrap;
  padding: 1rem;
}
</style>



// WEBPACK FOOTER //
// Plypp.vue?5b188fc8